<aside class="nav-sidebar">

  <!-- Action Bar -->
  <div class="action-bar">
    <div class="action-tabs">
      <button class="tab-btn" (click)="resetFilters()" [class.active]="!showSearch && !isSortedAZ">
        <mat-icon>home</mat-icon>
      </button>
      <button class="tab-btn" (click)="toggleSearch()" [class.active]="showSearch">
        <mat-icon>search</mat-icon>
      </button>
      <button class="tab-btn" (click)="toggleSort()" [class.active]="isSortedAZ">
        <span class="az-label">A-Z</span>
      </button>
    </div>
    <button class="sidebar-close" (click)="toggleSidebar()">
      <mat-icon>chevron_left</mat-icon>
    </button>
  </div>

  <!-- Search Box -->
  @if (showSearch) {
    <div class="search-box">
      <mat-icon class="search-ico">search</mat-icon>
      <input
        type="text"
        class="search-input"
        [placeholder]="'Search sports, events...' | translate"
        (input)="updateSearch($any($event.target).value)"
        autofocus />
      <mat-icon class="close-ico" (click)="toggleSearch()">close</mat-icon>
    </div>
  }

  <!-- Menu Section -->
  <div class="section">
    <div class="section-hdr">
      <span class="section-title">{{ "Menu" | translate }}</span>
    </div>
    <div class="section-card">
      <mat-accordion>
        <mat-expansion-panel
          class="nav-panel"
          [expanded]="localFavoritesPanelOpen"
          (opened)="handleFavoritesPanel('opened')"
          (closed)="handleFavoritesPanel('closed')">
          <mat-expansion-panel-header class="nav-panel-hdr">
            <mat-panel-title class="panel-title">
              <mat-icon class="panel-ico" [class.fav-active]="hasFavorites">star</mat-icon>
              <span>{{ "Favorites" | translate }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-favorites />
        </mat-expansion-panel>

        <mat-expansion-panel
          class="nav-panel sports-nav-panel"
          [expanded]="localSportsPanelOpen"
          (opened)="handleSportsPanel('opened')"
          (closed)="handleSportsPanel('closed')">
          <mat-expansion-panel-header class="nav-panel-hdr nav-panel-hdr--hidden">
          </mat-expansion-panel-header>
          <div class="nav-outlet">
            <router-outlet></router-outlet>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <!-- Top Leagues Section -->
  <div class="section">
    <div class="section-hdr">
      <span class="section-title">{{ "TOP LEAGUES" | translate }}</span>
    </div>
    <div class="section-card">
      @for (group of (topLeagues$ | async); track group.sport) {
        <div class="sport-group-label">{{ group.sport | translate | uppercase }}</div>
        @for (league of group.leagues; track league.leagueId) {
          <a class="league-item"
             [routerLink]="['/app/main', { outlets: { content: [group.sportRoute, 'league', league.leagueId, getLeagueDisplayName(league.leagueName)] } }]"
             routerLinkActive="active"
             (click)="handleClick()">
            <div class="item-left">
              <mat-icon class="league-ico">{{ getSportIcon(group.sport) }}</mat-icon>
              <span class="league-name">{{ getLeagueDisplayName(league.leagueName) }}</span>
            </div>
          </a>
        }
      } @empty {
        <div class="empty-leagues">{{ "No leagues available" | translate }}</div>
      }
    </div>
  </div>

</aside>
